import { Component, OnInit, Input, EventEmitter, OnChanges, SimpleChanges, ViewChild, Output } from '@angular/core';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, debounceTime, switchMap } from 'rxjs/operators';
import { ApplicationControlService } from '../../services/applicationcontrol.service';
import { AzureMapsService } from '../../services/azure-maps.service';
import { CityService } from '../../services/city.service';
import { UtilService } from '../../services/util.service';
import { City, SearchCityLookup, SearchCityState } from '../../models/models';

@Component({
    selector: 'city-state-zip-dropdown',
    templateUrl: './city-state-zip-dropdown.component.html',
    standalone: false
})
export class CityStateZipDropdown implements OnInit, OnChanges {
    @Input() parentForm: UntypedFormGroup = new UntypedFormGroup({});
    @Input() ctrlName: string = "cityCtrl";
    @Input() cityID: number = 0;
    @Input() placeholder: string = "Enter a City";
    @Input() isChooseFirstCity: boolean = false;
    @Input() isChooseDefaultZip: boolean = false;
    //@Input() isCityStateZip: boolean = false;
    @Input() isDisabled: boolean = false;
    @Input() isRequired: boolean = false;
    @Input() defaultCity: string = "";

    @Output() citySelected = new EventEmitter<any>(); // CityID
    @Output() cityBlurred = new EventEmitter<any>();

    @ViewChild('autoTrigger', { static: false, read: MatAutocompleteTrigger }) autoTrigger!: MatAutocompleteTrigger;
    @ViewChild('city', { static: false }) city!: MatAutocomplete;

    public cities: SearchCityLookup[] = [];
    public citiesStartsWith: Array<string> = [];
    public filteredCities: Observable<SearchCityLookup[]> = new Observable<SearchCityLookup[]>();
    public cityStateZipList: SearchCityState[] = [];
    public selectedCityST: string = "";
    public selectedCityID: number = 0;
    public ariaLabel: string = "";
    public isError: boolean = false;
    public isValidTimeZone: boolean = true;
    public timeZoneName: string = "";
    public cityLatitude: number = 0;
    public cityLongitude: number = 0;
    public errorDetail: string = "";
    private isAllowOnChange: boolean = true;
    public isKendo: boolean = false;

    constructor(private azureMapsService: AzureMapsService, private applicationControlService: ApplicationControlService,
        private cityService: CityService, private utilService: UtilService) {
    }

    ngOnInit() {
        this.applicationControlService.getApplicationControlsByAppName('UITypeaheadSource', false).subscribe(result => {
            if (result.length > 0) {
                this.isKendo = result[0].appSettingValue == "kendo";
                this.isKendo = false;
            }
        });
        //console.log("city-state-zip-dropdown:ngOnInit-before", this.defaultCity, this.selectedCityST, this.cityID, this.selectedCityID);
        this.initValues();
        //console.log("city-state-zip-dropdown:ngOnInit-after", this.defaultCity, this.selectedCityST, this.cityID, this.selectedCityID);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.isAllowOnChange) {
            var ok = changes;

            if (this.defaultCity && this.defaultCity != "") {
                this.placeholder = this.defaultCity;
                this.parentForm!.controls[this.ctrlName].setValue(this.defaultCity);
                this.selectedCityST = this.defaultCity;
            }

            if (changes.cityID == null || changes.cityID.currentValue == null) return;

            this.selectedCityID = parseInt(changes.cityID.currentValue);
            if (this.selectedCityID == 0) {
                //console.log("city-state-zip-dropdown:ngOnChanges-selectedCityID==0", this.defaultCity, this.selectedCityST, this.cityID, this.selectedCityID);
                this.selectedCityST = "";
                this.defaultCity = "";
                this.placeholder = "Enter a City";
                this.ariaLabel = "Enter a City";
                this.parentForm!.controls[this.ctrlName].setValue("");
            }
            else {
                //console.log("city-state-zip-dropdown:ngOnChanges-selectedCityID!=0", this.defaultCity, this.selectedCityST, this.cityID, this.selectedCityID);
                this.selectedCityID = this.cityID;
                //this.cityZipChanged(this.cityID);
                //this.optionChanged(this.cityID);
            }
            this.getCityZips();
            //console.log("city-state-zip-dropdown:ngOnChanges", this.defaultCity, this.selectedCityST, this.cityID, this.selectedCityID);
        }
        this.isAllowOnChange = true;
    }

    private initValues() {
        if (!this.placeholder) {
            this.placeholder = "Enter a City";
        }
        this.ariaLabel = this.placeholder;
        this.errorDetail = "Please " + this.placeholder.toLowerCase();
        //this.getCities();
        if (this.defaultCity != "") {
            this.placeholder = this.defaultCity;
            this.parentForm!.controls[this.ctrlName].setValue(this.defaultCity);
            if (this.cityID > 0) {
                this.selectedCityID = this.cityID;
            }
        }
        else {
            if (this.cityID > 0) {
                //this.optionChanged(this.cityID);
            }
        }
        this.cities.length = 0;
        this.citiesStartsWith.length = 0;
        //this.selectedCityID = 0;

        this.setFilter();
    }

    private setFilter() {
        this.filteredCities = this.parentForm!.controls[this.ctrlName].valueChanges.pipe(
            startWith(''),
            debounceTime(300),
            switchMap(city => city ? this.filterCities(city) : new Array())
            //map(city => city ? this.filterCities(city) : new Array())
        );
    }

    private filterCities(cityName: string) {
        if (typeof cityName !== 'string') return new Array();
        const filterValue = cityName.toLowerCase();
        if (filterValue.length < 2) return new Array();
        //if (this.citiesStartsWith.indexOf(filterValue) > -1) {
        //    // Get cached data
        //    return 
        //}
        return this.cityService.getSearchCityLookupStartsWith(cityName);
    }

    public getCityLookup(value: string) {
        //console.log("filterCustomers", value);
        this.cityService.getSearchCityLookupStartsWith(value).subscribe(result => {
            var lst: SearchCityLookup[] = result.resultCollection;
            lst = lst.sort((left, right): number => {
                if (left.cityST < right.cityST) return -1;
                if (left.cityST > right.cityST) return 1;
                return 0;
            });
            this.cities = lst;
        });
    }

    public chooseActiveCity(event: any) {
        //console.log("city-state-zip-dropdown:chooseActiveCity", event);
        if (this.autoTrigger.activeOption) {
            this.isAllowOnChange = false;
            var cityStateZip: SearchCityLookup = this.autoTrigger.activeOption.value;
            this.parentForm!.controls[this.ctrlName].setValue(cityStateZip);
            this.optionChanged(cityStateZip);
            return;
        }
        if (this.isChooseFirstCity != true || this.city.options.length < 1) return;

        this.parentForm!.controls[this.ctrlName].setValue(this.city.options.first.value);
    }

    public optionChanged(evt: any) {
        //console.log("city-state-zip-dropdown:optionChanged", evt);
        this.isAllowOnChange = false;
        if (this.isKendo) {
            var idx = this.cities.findIndex(t => t.cityID == evt);
            //console.log("optionChanged", idx);
            if (idx >= 0) {
                //console.log("optionChanged", this.cities[idx]);
                this.selectedCityID = this.cities[idx].cityID;
                this.selectedCityST = this.cities[idx].cityST;
                this.getCityZips();
            }
        }
        else {
            if (evt.option) {
                var cityStateZip: SearchCityLookup = evt.option.value;
                this.selectedCityID = cityStateZip.cityID;
                this.selectedCityST = cityStateZip.cityST;
                this.getCityZips();
            }
            else if (evt.cityID) {
                var cityStateZip: SearchCityLookup = evt;
                this.selectedCityID = cityStateZip.cityID;
                this.selectedCityST = cityStateZip.cityST;
                this.getCityZips();
            }
            else {
                this.selectedCityID = 0;
                this.selectedCityST = "";
                this.cityStateZipList = [];
                this.timeZoneName = "";
                this.isValidTimeZone = true;
            }
        }
        this.filteredCities = new Observable<SearchCityLookup[]>();

        this.setFilter();
    }

    public getCityZips() {
        if (this.selectedCityST != null && this.selectedCityST != "") {
            this.cityService.getSearchCityStateByCityST(this.selectedCityST).subscribe(result => {
                this.cityStateZipList = result.resultCollection;
                if (this.isChooseDefaultZip) {
                    var defaultZip = this.cityStateZipList.find(t => t.defaultCityStateRecord == true);
                    if (defaultZip != null) {
                        this.selectedCityID = defaultZip.cityID;
                        console.log("city-state-zip-dropdown:getCityZips:defaultZip", this.selectedCityID, defaultZip);
                        this.checkTimeZone(defaultZip);
                        this.citySelected.emit(defaultZip.cityID);
                    }
                }
                else if (this.cityStateZipList.length > 0) {
                    if (this.selectedCityID > 0 && this.defaultCity != "" && !this.isChooseFirstCity) {
                        var selectedCity = this.cityStateZipList.find(t => t.cityID == this.selectedCityID);
                        this.checkTimeZone(selectedCity!);
                        this.cityZipChanged(this.selectedCityID);
                    }
                    else {
                        var firstCity = this.cityStateZipList[0];
                        this.selectedCityID = firstCity.cityID;
                        console.log("city-state-zip-dropdown:getCityZips:firstCity", this.selectedCityID, firstCity);
                        this.checkTimeZone(firstCity);
                        this.citySelected.emit(firstCity.cityID);
                    }
                }
            });
        }
    }

    public optionBlurred() {
        //console.log("city-state-zip-dropdown:optionBlurred", this.selectedCityST, this.selectedCityID, this.citiesStartsWith, this.cities);
        //if (this.citiesStartsWith.length == 0) {
        //    this.citySelected.emit(0);
        //}
        //this.cityBlurred.emit();
    }

    public displayCity(city?: SearchCityLookup): string | undefined {
        return city ? city.cityST : undefined;
        //return city ? city.cityStateZip : undefined;
    }

    private checkTimeZone(searchCity: SearchCityState) {
        this.timeZoneName = searchCity.windowsRegistryTimeZoneName == null ? "" : searchCity.windowsRegistryTimeZoneName;
        if (searchCity.epiTimeZoneID > 0) {
            this.isValidTimeZone = true;
        }
        else {
            if (searchCity.latitude != null && searchCity.latitude != 0 && searchCity.longitude != null && searchCity.longitude != 0) {
                this.cityLatitude = searchCity.latitude;
                this.cityLongitude = searchCity.longitude;
            }
            this.isValidTimeZone = false;
        }
    }

    public updateTimeZone() {
        if (this.selectedCityID > 0 && this.cityLatitude != 0 && this.cityLongitude != 0) {
            this.utilService.isLoading = true;
            this.cityService.saveCityLatLonTimeZone(this.selectedCityID, this.cityLatitude, this.cityLongitude).subscribe(result => {
                var city: City = result.resultCollection[0];
                //this.timeZoneName = city.epiTimeZone.windowsRegistryTimeZoneName;
                this.cityService.getSearchCityStateByCityID(this.selectedCityID).subscribe(result2 => {
                    this.utilService.isLoading = false;
                    var searchCity: SearchCityState = result.resultCollection[0];
                    this.timeZoneName = searchCity.windowsRegistryTimeZoneName;
                    this.isValidTimeZone = true;
                });
            });
        }
    }

    public isValid() {
        if (this.isRequired == true) {
            return this.selectedCityID > 0;
            //return this.parentForm!.controls[this.ctrlName].hasError('required');
        }
        else {
            return true;
        }
    }

    public cityZipChanged(evt: any) {
        this.isAllowOnChange = false;
        var cityID;
        if (evt.target) {
            cityID = evt.target.value;
        }
        else {
            cityID = parseInt(evt);
        }
        console.log("city-state-zip-dropdown:cityZipChanged", cityID, evt);
        this.selectedCityID = cityID;
        this.citySelected.emit(cityID);
    }
}
